<div fxLayoutAlign="end end">
	<mat-form-field
		id="inputContainer"
		(click)="animate()"
		[mtxPopoverTriggerFor]="quickSearchPopover"
		class="quick-search-bar"
		floatLabel="never"
		mtxPopoverTriggerOn="none"
	>
		<mat-icon class="color-white vertical-align-middle m-l-1 m-r-1" matPrefix>search</mat-icon>
		<input
			#search
			(ngModelChange)="onSearchChange($event)"
			[(ngModel)]="quickSearchString"
			[placeholder]="placeholderText"
			autocomplete="off"
			matInput
		/>
	</mat-form-field>
	<mtx-popover
		#quickSearchPopover="mtxPopover"
		[closeOnPanelClick]="false"
		[closeOnBackdropClick]="true"
	>
		<mat-card class="p-0 quick-search-dropdown" id="quickSearchPopoverCard">
			<mat-card-content>
				<div fxLayout="row">
					<div fxFlex>
						<div class="p-1 label-text-light" fxLayout="row">
							Start typing to search {{ IS_CARRIER ? 'brokers' : 'carriers' }} and projects
						</div>
						<div class="p-1 label-text-light" fxLayout="row">
							Search by name, email, phone, origin, or destination; Search by mc either mc-12345 or
							mc:12345, Search by dot with either dot-12345 or dot:12345, Search by code with
							either code-ABC123 or code:ABC123
						</div>
					</div>
					<div class="p-1" fxFlex="10" fxLayoutAlign="end start">
						<mat-icon
							(click)="quickSearchString = ''; animate(); closePopover()"
							class="primary-text cursor-pointer"
						>
							close
						</mat-icon>
					</div>
				</div>
			</mat-card-content>
			<div class="p-0" fxLayout="row">
				<div fxFlex="50">
					<app-broker-search-results
						#brokerSearchResultsComponent
						(closePopover)="trigger.closePopover()"
						*ngIf="IS_CARRIER"
						[brokerSearchString]="quickSearchString"
						[pendingHTTPRequests]="pendingHTTPRequests"
					>
					</app-broker-search-results>
					<app-carrier-search-results
						#carrierSearchResultsComponent
						(closeCarrierFullProfile)="closeCarrierFullProfileHandler()"
						(openCarrierFullProfile)="openCarrierFullProfileHandler($event)"
						*ngIf="!IS_CARRIER"
						[carrierSearchString]="quickSearchString"
						[laneDetails]="laneDetails"
						[pendingHTTPRequests]="pendingHTTPRequests"
					>
					</app-carrier-search-results>
				</div>
				<div fxFlex="50">
					<app-project-search-results
						#projectSearchResultsComponent
						(closePopover)="trigger.closePopover()"
						[pendingHTTPRequests]="pendingHTTPRequests"
						[projectSearchString]="quickSearchString"
					>
					</app-project-search-results>
				</div>
			</div>
		</mat-card>
	</mtx-popover>
</div>
